/**
 * The timezone the hours screens group punches into days with.
 *
 * Deliberately NOT the browser's zone. These screens used to key days by the
 * viewer's local date, so a manager in California opening a Texas tenant's
 * timesheet saw punches near local midnight land on a different day than the
 * employee did — and than the timesheet and payroll APIs did, which keyed by
 * a UTC-derived date. All four now resolve the day through the TENANT's zone.
 *
 * The value arrives on the tenant record via `getMyTenants` at login and at
 * session restore. When either of those failed, or the tenant record has no
 * timezone, `resolveTimeZone` supplies the signup default rather than letting
 * the screen fall back to the browser and silently disagree with the API.
 */
import { resolveTimeZone } from '@lalohr/utils';
import { selectTenantTimeZone, useAuthStore } from '../stores/auth.store';
export function useTenantTimeZone() {
    const stored = useAuthStore(selectTenantTimeZone);
    return resolveTimeZone(stored);
}
